import { Modal as BaseModal } from "antd";
import styled from "styled-components";

const Modal = styled(BaseModal).attrs((props) => ({
  footer: null,
  overflowX: props.overflowX || "hidden",
  maxWidth: props.maxWidth || "unset",
  width: props.width || "100%",
}))`
  .ant-modal-content {
    border-radius: 8px;
    width: 100%;
    max-width: ${({ maxWidth }) => maxWidth};
    margin: auto;
    overflow-x: ${({ overflowX }) => overflowX};
  }

  .ant-modal-header {
    border-radius: inherit;
    border: none;
    padding-left: 16px;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: 700;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
  }

  .ant-modal-body {
    padding: 0px;
  }
`;

export default Modal;
